<style>
@import '../custom/css/cadastro.css';
</style>

<template>
  <div class="container">
    <b-row>
      <b-col cols="12" class="text-center mt-4">
        <h1 class="h1-after-center text-uppercase fwb mb-4">
          Dados Cadastrais para Demostração
        </h1>
        <div class="box-desc text-center">
          <p class="roboto-n max-w-500 m-0-auto p-b-3em">
            Preencha seus dados cadastrais abaixo.
          </p>
        </div>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12" lg="6">
        <div class="form-group">
          <label for="cadastroCnpj"> CNPJ *</label>
          <input
            type="text"
            v-model="Fields.cnpj"
            class="form-control"
            id="cadastroCnpj"
            v-mask="'##.###.###/####-##'"
            aria-describedby="CNPJ para cadastro da empresa"
            placeholder="Digite o CNPJ da empresa"
            @input="ErrorMessages.cnpj = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.cnpj !== null"
          >
            {{ ErrorMessages.cnpj }}
          </p>
        </div>
      </b-col>

      <b-col cols="12" lg="6">
        <div class="form-group">
          <label for="cadastroRazaoSocial"> Razão Social *</label>
          <input
            type="text"
            class="form-control"
            v-model="Fields.razao_social"
            id="cadastroRazaoSocial"
            aria-describedby="Razão Social para cadastro da empresa"
            placeholder="Digite a razão social da empresa"
            @input="ErrorMessages.companyName = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.companyName !== null"
          >
            {{ ErrorMessages.companyName }}
          </p>
        </div>
      </b-col>

      <b-col cols="12" lg="6">
        <div class="form-group">
          <label for="cadastroNomeFantasia"> Nome Fantasia *</label>
          <input
            type="text"
            v-model="Fields.nome_fantasia"
            class="form-control"
            id="cadastroNomeFantasia"
            aria-describedby="Nome Fantasia para cadastro da empresa"
            placeholder="Digite o nome fantasia da empresa"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.fantasyName !== null"
          >
            {{ ErrorMessages.fantasyName }}
          </p>
        </div>
      </b-col>
      <b-col cols="12" lg="6">
        <div class="form-group">
          <label for="cadastroNomeResponsavel"> Nome Responsável *</label>
          <input
            type="text"
            v-model="Fields.nome_responsavel"
            class="form-control"
            id="cadastroNomeResponsavel"
            aria-describedby="Nome do Responsável para cadastro da empresa"
            placeholder="Digite o nome do Responsável da empresa"
            @input="ErrorMessages.responsibleName = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.responsibleName !== null"
          >
            {{ ErrorMessages.responsibleName }}
          </p>
        </div>
      </b-col>
      
      <b-col cols="12" lg="6">
        <div class="form-group">
          <label for="cadastroCelular"> WhatsApp/Telefone *</label>
          <input
            type="text"
            v-model="Fields.celular"
            class="form-control"
            id="cadastroCelular"
            v-mask="['(##) #####-####', '(##) ####-####']"
            aria-describedby="Celular para cadastro da empresa"
            placeholder="Digite o celular da empresa"
            @input="ErrorMessages.cellPhone = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.cellPhone !== null"
          >
            {{ ErrorMessages.cellPhone }}
          </p>
        </div>
      </b-col>
    </b-row>

    <b-row class="mb-4">
      <b-col cols="12">
        <h4 class="mt-4 mb-1 text-center">Dados de Acesso</h4>
      </b-col>
      <b-col cols="12" >
        <div class="form-group">
          <label for="cadastroEmail"> E-mail *</label>
          <input
            type="text"
            v-model="Fields.email"
            @blur="validEmail()"
            class="form-control"
            id="cadastroEmail"
            aria-describedby="Email para cadastro da empresa"
            placeholder="Digite um E-mail para acessar a plataforma"
            @input="ErrorMessages.email = null"
          />
          <p
            class="error-message text-danger"
            v-if="ErrorMessages.email !== null"
          >
            {{ ErrorMessages.email }}
          </p>
        </div>
      </b-col>
      <b-col cols="12" lg="6">
        <div class="form-group">
          <InputPassword
            :label="'Senha *'"
            :value.sync="Fields.password"
            :errorMessage.sync="ErrorMessages.password"
          />
        </div>
      </b-col>
      <b-col cols="12" lg="6">
        <InputPassword
          :label="'Confirme sua senha *'"
          :value.sync="Fields.confirm_senha"
          :errorMessage.sync="ErrorMessages.confirm_password"
          :placeholder="'Digite novamente a sua senha'"
        />
      </b-col>

      <b-col cols="12" class="mt-3">
        <div class="form-group d-flex justify-center mb-0 pb-0">
          <b-form-checkbox
            id="termoConfirmacao"
            name="termoConfirmacao"
            v-model="acceptedTermsAndConditions"
            @input="ErrorMessages.confirmationTerm = null"
            required
          >
          </b-form-checkbox>

          <div class="font-weight-normal">
            Li e aceito os
            <span class="c-orange c-pointer" v-b-modal="'termos'"
              >termos e condições</span
            >
            e as
            <span class="c-orange c-pointer" v-b-modal="'politicaPrivacidade'"
              >politicas de privacidade.</span
            >
          </div>

          <p
            class="error-message text-danger"
            v-if="ErrorMessages.confirmationTerm !== null"
          >
            {{ ErrorMessages.confirmationTerm }}
          </p>
        </div>
         <div class="mt-2"> Campos obrigatórios! (*)</div>
      </b-col>

      <b-col cols="12" class="mt-4">
        <b-button 
          @click="register()"
          variant="success" 
          block  
          :disabled="!isValidReq && !isValidEmail"
        ><i class="fas fa-save mr-2"></i>Cadastrar</b-button>
      </b-col>
    </b-row>

    <PrivacyPolicy />
    <TermsAndConditions />
    <SolicitateAppModal ref="solicitateAppModal" @success="delayedLogin()" />
  </div>
</template>

<script>
// import { mapState, mapGetters, mapActions } from 'vuex';
import PrivacyPolicy from '../components/PrivacyPolicy.vue';
import TermsAndConditions from '../components/TermsAndConditions.vue';

import InputPassword from '../components/Inputs/InputPassword.vue';
import makeToast from '../mixins/makeToast';
import login from '../mixins/login';
import SolicitateAppModal from './lojista/new-app/SolicitateAppModal.vue';

export default {
  name: "cadastroDemo",
  mixins: [makeToast, login],
  components: {
    PrivacyPolicy,
    TermsAndConditions,
    InputPassword,
    SolicitateAppModal
  },
  data() {
    return {
      Fields: {
        razao_social: '',
        nome_fantasia: '',
        nome_responsavel: '',
        cnpj: '',
        celular: '',
        email: '',
        password: '',
        confirm_senha: '',
        plano: 3,
        plano_id: null,
        planoIdValid: false,
        novoApp: true,
        tipo_usuario_id: 3,
        validAceite: true,
      },
      ErrorMessages: {
        companyName: null,
        fantasyName: null,
        responsibleName: null,
        cnpj: null,
        cellPhone: null,
        email: null,
        confirmationTerm: null,
        privacyPolicy: null,
        paymentPlan: null,
        password: null,
        confirm_password: null,
      },
      isValidEmail: false,
      isValidReq: false,
      tipoUsuario: 3,
      acceptedTermsAndConditions: false,

    };
  },

  watch: {
    'Fields.cnpj': function () {
      if (this.Fields.cnpj.length === 18) {
        this.validarCnpj();
      }
    },
  },

  methods: {
    validEmail() {
      if (this.Fields.email === '' || this.Fields.email === null) {
        return;
      }

      const data = {
        email: this.Fields.email,
      };

      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('user/validarEmail', data)
        .then((response) => {
          if (response.data.valid) {
            this.ErrorMessages.email = 'Email já está sendo utilizado!';
            this.isValidEmail = false;
          } else {
            this.ErrorMessages.email = null;
            this.isValidEmail = true;
          }
        })
        .catch(() => {
          this.makeToast('Oopss!', 'Tente novamente!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },

    validarCnpj() {
      this.$store.dispatch('startLoader');
      this.$store
        .dispatch('user/validarCnpj', this.Fields.cnpj.replace(/[^0-9]/g, ''))
        .then((response) => {
          if (response.data.valid) {
            this.ErrorMessages.cnpj = 'CNPJ já está sendo utilizado!';
            this.isValidReq = false;
          } else {
            this.ErrorMessages.cnpj = null;
            this.isValidReq = true;
          }
        })
        .catch(() => {
          this.makeToast('Oopss!', 'Tente novamente!', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },

    register() {
      this.Fields.tipo_usuario_id = 3;
      if (this.validateFields()) {
        this.$store.dispatch('startLoader');
        this.$store
          .dispatch('shopkeeper/registerDemo', this.Fields)
          .then((response) => {

            this.$store.dispatch('endLoader');

              if(response.data.info && response.data.info.id) {
                this.info = response.data.info;
              }
              const data = {
                id: response.data.id,
                shopkeeperId: response.data.shopkeeperId,
                name: this.Fields.nome_fantasia,
                tipo_usuario_id: 3,
              };
              this.$store.dispatch('createSubAccount', data);

              this.makeToast('Sucesso!', response.data.message);
     
              this.$refs.solicitateAppModal.open({
                shopkeeperId: data.shopkeeperId,
                info: response.data.info,
                isDemo: true
              });
          })
          .catch(() => {
            this.$store.dispatch('endLoader');
            this.makeToast('Oopss!', 'email já cadastrado!', 'danger');
            this.$bvModal.show('login');
            localStorage.setItem('emailField', this.Fields.email);
          });
      } else {
        this.makeToast(
          'Oopss!',
          'Parece que há campos inválidos! Corrija-os e tente novamente',
          'danger'
        );
      }
    },
    validateFields() {
      let isValid = true;

      if (!this.$validate.name(this.Fields.razao_social)) {
        this.ErrorMessages.companyName = 'Razão inválida';
        isValid = false;
      }

      if (!this.$validate.name(this.Fields.nome_fantasia)) {
        this.ErrorMessages.fantasyName = 'Nome Fantasia inválido';
        isValid = false;
      }

      if (!this.$validate.name(this.Fields.nome_responsavel)) {
        this.ErrorMessages.responsibleName = 'Nome do Responsavel inválido';
        isValid = false;
      }

      if (!this.$validate.cnpj(this.Fields.cnpj)) {
        this.ErrorMessages.cnpj = 'CNPJ inválido';
        isValid = false;
      }

      if (!this.$validate.email(this.Fields.email)) {
        this.ErrorMessages.email = 'Email inválido';
        isValid = false;
      }

      if (!this.$validate.telephone(this.Fields.celular)) {
        this.ErrorMessages.cellPhone = 'Celular inválido';
        isValid = false;
      }

      if (!this.$validate.password(this.Fields.password)) {
        this.ErrorMessages.password =
          'A senha precisa ter no mínimo 5 Caracteres';
        isValid = false;
      }

      if (this.Fields.confirm_senha !== this.Fields.password) {
        this.ErrorMessages.confirm_password = 'As senhas devem ser iguais';
        isValid = false;
      }

      if (!this.acceptedTermsAndConditions) {
        this.ErrorMessages.confirmationTerm =
          'Você precisa aceitar os termos e condições';
        isValid = false;
      }
      return isValid;
    },

    delayedLogin() {
      localStorage.setItem("isDemoApp", true);
      setTimeout(() => {
        this.login(this.Fields.email, this.Fields.password, false, true);
      }, 1000);
    }, 
  },
};
</script>